import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

// eslint-disable-next-line react/function-component-definition
export const MNPSuccess = () => {
  const {
    nextStep,
    setShowActivationHeader,
    withMNP,
    setStep3SubStep,
    phoneNumberActivationForm: { oldNumberComplete, msisdn }
  } = useActivation();

  let imageContent = {};
  let headerContent = {};
  let copyTextContent = {};
  let buttonContent = {};

  if (withMNP) {
    imageContent = useCmsImage('ek_reg_mnp_suc_web_bg');
    headerContent = tA11y('ek_reg_mnp_suc_hdl1');
    headerContent = replaceDynamicCmsContent(headerContent, '{MSISDN}', oldNumberComplete);
    copyTextContent = tA11y('ek_reg_mnp_suc_txt1');
    buttonContent = tA11y('ek_reg_suc_btn1');
  } else {
    imageContent = useCmsImage('ek_reg_without_mnp_suc_web_bg');
    headerContent = tA11y('ek_reg_without_mnp_suc_hdl1');
    headerContent = replaceDynamicCmsContent(headerContent, '{MSISDN}', msisdn);
    copyTextContent = {};
    buttonContent = tA11y('ek_reg_suc_btn1');
  }

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          icon={appIconsPath.CELEBRATE}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            nextStep();
            setStep3SubStep(0);
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
};

export default MNPSuccess;
